module.exports = __webpack_public_path__ + "static/13-c761d41ff2902474895a6525977204f5.jpg";